import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import Hidden from './Icons/Hidden';
const MatureStrictBlockedOverlay = (props)=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
        icon: /*#__PURE__*/ React.createElement(Hidden, null),
        title: t('deviationview.blocked.mature.strict'),
        text: t('deviationview.blocked.mature.strict.text'),
        strict: true
    }, props));
};
MatureStrictBlockedOverlay.displayName = 'MatureStrictBlockedOverlay';
export default MatureStrictBlockedOverlay;
